// extracted by mini-css-extract-plugin
module.exports = {"sliderMarquee":"SliderMarquee_sliderMarquee__VRE1j","rfm-child":"SliderMarquee_rfm-child__MisP9"};